module.exports = __webpack_public_path__ + "img/55250tq2.fe017ad2.gif";